export const keyCustomCode = 'custom-code-plugin__code';
export const typeCustomCode = 'custom-code';
export const commandNameCustomCode = 'custom-code:open-modal';